export const GLOBAL_STATE = 'Account'

export const ACCOUNT = 'account'
export const ACCOUNT_CREATE = 'create'
export const ACCOUNT_LIST = 'accountList'
export const ACCOUNT_ALL = 'accountAll'
export const ACCOUNT_TYPES = 'accountTypes'
export const ACCOUNT_PROFILE_UPDATE = 'profileUpdate'
